import { render, staticRenderFns } from "./EtapaVendedor.vue?vue&type=template&id=565b3aa9"
import script from "./EtapaVendedor.vue?vue&type=script&lang=js"
export * from "./EtapaVendedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports